import { ApolloError } from "@apollo/client";
import { Alert } from "@mui/material";

import { GqlPlannerV2TransportationMethod } from "~/__generated__/graphql/types.ts";
import { GaiaExpandableMapMarkerBody } from "~/modules/plannerV2/components/GaiaExpandableMapMarker/GaiaExpandableMapMarkerBody";

import {
    GaiaExpandableMapMarkerFieldworkerAvailableTransportationMethodsFragment,
    GaiaExpandableMapMarkerFieldworkerAvailableTravelGroupsFragment,
    GaiaExpandableMapMarkerFieldworkerBodyFragment,
} from "./fragments.generated";
import { GaiaExpandableMapMarkerFieldworkerBodyAddToCarpoolButton } from "./GaiaExpandableMapMarkerFieldworkerBodyAddToCarpoolButton";
import { GaiaExpandableMapMarkerFieldworkerBodyAddToVisitButton } from "./GaiaExpandableMapMarkerFieldworkerBodyAddToVisitButton.tsx";
import { GaiaExpandableMapMarkerFieldworkerBodyProfile } from "./GaiaExpandableMapMarkerFieldworkerBodyProfile";

type GaiaExpandableMapMarkerFieldworkerBodyProps = {
    fieldworker: GaiaExpandableMapMarkerFieldworkerBodyFragment;
    availableTravelGroups: GaiaExpandableMapMarkerFieldworkerAvailableTravelGroupsFragment[];
    onAddToVisitClick: (transportationMethod: GqlPlannerV2TransportationMethod) => void;
    onAddToTravelGroupClick: ({
        plannerTravelGroupId,
        fieldworkerId,
    }: {
        plannerTravelGroupId: string;
        fieldworkerId: string;
    }) => void;
    isBeingAdded: boolean;
    availableTransportationMethods?: GaiaExpandableMapMarkerFieldworkerAvailableTransportationMethodsFragment[];
    error?: ApolloError;
};

export function GaiaExpandableMapMarkerFieldworkerBody({
    fieldworker,
    availableTravelGroups,
    onAddToVisitClick,
    onAddToTravelGroupClick,
    isBeingAdded,
    error,
    availableTransportationMethods,
}: GaiaExpandableMapMarkerFieldworkerBodyProps) {
    return (
        <GaiaExpandableMapMarkerBody>
            <GaiaExpandableMapMarkerFieldworkerBodyProfile fieldworker={fieldworker} />
            {error && <Alert severity="error">{error.message}</Alert>}
            {availableTransportationMethods?.map(availableTransportationMethod => (
                <GaiaExpandableMapMarkerFieldworkerBodyAddToVisitButton
                    key={availableTransportationMethod.transportationMethod}
                    availableTransportationMethod={availableTransportationMethod}
                    disabled={isBeingAdded}
                    onClick={onAddToVisitClick}
                    hasMoreThanOneOption={availableTransportationMethods.length > 1}
                />
            ))}
            {availableTravelGroups.map(travelGroup => (
                <GaiaExpandableMapMarkerFieldworkerBodyAddToCarpoolButton
                    disabled={isBeingAdded}
                    key={travelGroup.id}
                    travelGroup={travelGroup}
                    onClick={() =>
                        onAddToTravelGroupClick({
                            plannerTravelGroupId: travelGroup.id,
                            fieldworkerId: fieldworker.id,
                        })
                    }
                />
            ))}
        </GaiaExpandableMapMarkerBody>
    );
}
